import React, { useEffect, useState } from "react"

import SearchTablePublic from '../../../../CSIComponents/SearchTable/SearchTable'
import { LocalPersistence } from "../../../../../factories";
import { getMeetingRooms } from '../../../../../services/meetingrooms'
import { sortHelper } from '../../../../../helpers/misc/sortHelper'

interface propsTypes {
    tableData:object,
    setCurrentLine:() => {},
    setCurrentOneNav:() => {}
}

const MeetingRoomsSub = (props:propsTypes) => {
    const [dataSource, setDataSource] = useState<object[]>([])
    const [loadingFlag, setLoadingFlag] = useState<boolean>(true)
    useEffect(() => {
        getAllData()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
    const getAllData = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        const res =  await getMeetingRooms(session.supplier, session.propertyId);
        setLoadingFlag(false)
        if (res.result.success) {
            let resp = res?.property?.meetingrooms?.meetingroom || []
            resp.forEach((item:any, index:any) => { item.key = '' + index; })
            setDataSource(resp)
        }
    }
    const zhhColumns = [
        {
            title: '',
            key: 'index',
            // @ts-expect-error
            render: (text: string, record: [], index: number) => Number(record?.key) ? Number(record?.key) + 1 : index += 1,
            width: '40px'
        },
        {
            title: 'Room ID',
            dataIndex: 'id',
            key: 'id',
            ellipsis:'true',
            sorter: (a: [], b: []) => sortHelper(a, b, 'id'),
            showSorterTooltip: false
        },
        {
            title: 'Room Name',
            dataIndex: 'name',
            key: 'name',
            ellipsis:'true',
            sorter: (a: [], b: []) => sortHelper(a, b, 'name'),
            showSorterTooltip: false
        },
        {
            title: 'Total Area',
            dataIndex: 'area',
            key: 'area',
            ellipsis:'true',
            sorter: (a: [], b: []) => sortHelper(a, b, 'area'),
            showSorterTooltip: false
        },
        {
            title: 'Length',
            dataIndex: 'length',
            key: 'length',
            ellipsis:'true',
            sorter: (a: [], b: []) => sortHelper(a, b, 'length'),
            showSorterTooltip: false
        },
        {
            title: 'Width',
            dataIndex: 'width',
            key: 'width',
            ellipsis:'true',
            sorter: (a: [], b: []) => sortHelper(a, b, 'width'),
            showSorterTooltip: false
        },
        {
            title: 'Height',
            dataIndex: 'height',
            key: 'height',
            ellipsis:'true',
            sorter: (a: [], b: []) => sortHelper(a, b, 'height'),
            showSorterTooltip: false
        },
    ]
    return (
        <div style={{margin:'0 -32px'}}>
            <SearchTablePublic 
                addButton={true} 
                columns={zhhColumns} 
                dataSourceProps={dataSource} 
                setCurrentLine={props.setCurrentLine} 
                setAddFlag={props.setCurrentOneNav} 
                pageFlag={'meetingrooms'} 
                searchPlaceHloder={'Search Meeting Rooms'} 
                searchLabel={'Search'} 
                pageName="Meeting Rooms"
                loadingFlag={loadingFlag}
                pagination="meeting_rooms"
            />
        </div>
    )
}

export default MeetingRoomsSub
